import { cn } from "../../utilities/tailwind";

export type ExpandableIndicatorProperties = {
  className?: string | undefined;
  height?: number | undefined;
  width?: number | undefined;
};
export const ExpandableIndicator = ({
  height = 16,
  width = 16,
  className = "",
}: ExpandableIndicatorProperties) => (
  <svg
    className={cn(
      "transition-all duration-300 group-aria-expanded/expandable-ui:-scale-y-100",
      className,
    )}
    height={height}
    viewBox="0 0 60 60"
    width={width}
  >
    <path
      d="M10 20 L 30 40 L 50 20"
      fill="transparent"
      stroke="currentColor"
      strokeLinecap="round"
      strokeWidth="4"
    />
  </svg>
);
ExpandableIndicator.displayName = "ExpandableIndicator";
